/**
 * ToastContext.js
 * Proveedor global de notificaciones toast (CoreUI 5).
 * Uso en cualquier componente:
 *   const { showToast } = useToast();
 *   showToast('Guardado correctamente', 'success');
 */
import React, { createContext, useCallback, useContext, useState } from 'react';
import { CToast, CToastBody, CToastClose, CToaster } from '@coreui/react';

const ToastContext = createContext(null);

let toastIdCounter = 0;

export const ToastProvider = ({ children }) => {
  const [toasts, setToasts] = useState([]);

  const showToast = useCallback((message, color = 'success', delay = 4000) => {
    const id = ++toastIdCounter;
    setToasts(prev => [...prev, { id, message, color, delay }]);
  }, []);

  const removeToast = useCallback((id) => {
    setToasts(prev => prev.filter(t => t.id !== id));
  }, []);

  return (
    <ToastContext.Provider value={{ showToast }}>
      {children}
      <CToaster placement="bottom-end" className="p-3" style={{ zIndex: 9999 }}>
        {toasts.map(t => (
          <CToast
            key={t.id}
            autohide
            delay={t.delay}
            color={t.color}
            onClose={() => removeToast(t.id)}
            visible
            className="text-white"
          >
            <div className="d-flex align-items-center">
              <CToastBody className="flex-grow-1">{t.message}</CToastBody>
              <CToastClose className="me-2 m-auto" white />
            </div>
          </CToast>
        ))}
      </CToaster>
    </ToastContext.Provider>
  );
};

export const useToast = () => {
  const ctx = useContext(ToastContext);
  if (!ctx) throw new Error('useToast debe usarse dentro de <ToastProvider>');
  return ctx;
};
